import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AsyncFunction } from "../../functions/AsyncFunction";

// Stateの初期状態
const initialState = {
    organizer_id: "",
    party_date: "",
    party_start_time: "",
    no_select_menu_id_list: "",
    party_name: "",
    description: "",
    menu_group_id: "",
    coupon_code: "",
    inquiry: "",
    planned_number: "",
    wfpf_number: "",
    payment_bill_flag: "0",
    payment_paypay_flag: "0",
    payment_others_flag: "0",
    payment_bill_company: "",
    payment_others_detail: "",
    origin: window.location.origin,
    confirmation: false,
    menu_group_name: "",
    price: "",
    menu_name: [],
};

// Sliceを生成する
const slice = createSlice({
    name: "ApplicationForm",
    initialState,
    reducers: {
        ApplicationForm_initialize: () => initialState,
        ApplicationFormSet: (state, action) => {
            const name = action.payload[0];
            const value = action.payload[1];
            state[name] = value;
        },
        ApplicationFormSet_All: (state, action) => {
            for (let key in action.payload[0]) {
                state[key] = action.payload[0][key] ? action.payload[0][key] : "";
            }
        },
    },
});

export const GetGroupDetail = function (arg) {
    const params = {
        url: "/api/GetGroupDetail",
        method: "GET",
        params: { ...arg },
        type_name: "GetGroupDetail",
    };
    return AsyncFunction(params);
};

//懇親会申し込み
export const CreateParty = function (arg) {
    const params = {
        url: "/api/CreateParty",
        method: "POST",
        params: { ...arg },
        type_name: "CreateParty",
    };
    return AsyncFunction(params);
};

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const { ApplicationForm_initialize, ApplicationFormSet, ApplicationFormSet_All } = slice.actions;
